var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgULogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3209 2.40597C17.3985 1.78507 17.6313 1.24179 18.097 0.776119C18.485 0.388059 18.9507 0.155224 19.4164 0H22.6761V5.35522H20.0373C19.2612 5.35522 18.6403 5.12239 18.1746 4.5791C17.7089 4.11343 17.4761 3.57015 17.3985 2.94926V2.40597H17.3209ZM0.479076 0.0776117H3.66117C4.20445 0.155224 4.59251 0.465672 4.98057 0.853732C5.44624 1.3194 5.67908 1.86269 5.75669 2.48358V3.02687C5.67908 3.64776 5.44624 4.19104 4.98057 4.65672C4.43729 5.2 3.81639 5.43284 3.11788 5.43284H0.479076V0.0776117ZM19.494 22.7403C17.3985 24.9134 14.6821 26 11.5 26C8.31788 26 5.67908 24.9134 3.50594 22.7403C1.41042 20.5672 0.323853 17.8507 0.323853 14.6687V7.99403H5.67908C5.67908 7.99403 5.67908 15.5224 5.67908 15.6776C5.8343 16.997 6.37758 18.1612 7.38654 19.1701C8.55072 20.3343 9.87012 20.8776 11.4224 20.8776C12.9746 20.8776 14.294 20.3343 15.4582 19.1701C16.1567 18.4716 16.7 17.6955 16.9328 16.7642C17.088 16.2209 17.1656 15.6776 17.1656 15.0567V7.99403H22.5209V14.6687C22.6761 17.8507 21.5895 20.5672 19.494 22.7403Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgULogo);
export default __webpack_public_path__ + "static/media/U_logo.bad0a6d806f6f36c11f7dbbdc3ae5699.svg";
export { ForwardRef as ReactComponent };